import React, {useRef, useEffect} from 'react';
import ReactDOM from 'react-dom';
import ButtonTransparent from "@atoms/button.transparent";
import PerfectScrollbar from 'react-perfect-scrollbar'
import {isEmpty} from "../../helpers/helpers";
import {useWindowSize} from "../../helpers/windows.size";
import CloseIcon from '@icons/close.svg';

const Portal = ({show, children, onClose, className, modalDialogClass, dialogBodyClassName, scrollable}) => {
    const containerRef = useRef('');
    const bodyRef = useRef('');
    const contentRef = useRef('');
    const headerRef = useRef('');
    const backdropRef = useRef('');
    let windowSize = useWindowSize();

    const handleClose = (e) => {
        if (containerRef.current.children.length) {
            for (let item of containerRef.current.children) {
                if (item) {
                    item.classList.remove('show-modal')
                }
            }
        }

        containerRef.current.classList.remove('show-modal');
        backdropRef.current.classList.remove('in');
        bodyRef.current.classList.add('slide-out');

        setTimeout(() => {
            onClose(true);
        }, 300)
    };

    const handleDragEnd = (event) => {
        event.preventDefault();

        if (window.innerWidth < 767) {
            const {clientY, pageX} = event.changedTouches[0];
            const contentHeight = contentRef.current.clientHeight;
            const windowsHeight = window.innerHeight;
            const allowDray = (windowsHeight - (contentHeight / 2)) + 10;

            if (clientY > allowDray) {
                handleClose();
            } else {
                if (contentHeight < windowsHeight) {
                    bodyRef.current.style.height = contentHeight + 'px';
                } else {
                    bodyRef.current.style.height = 'calc(100vh - 80px)';
                }
            }
        }
    };

    const handleDrag = (event) => {
        event.preventDefault();

        if (window.innerWidth < 767) {
            const {clientY, pageX} = event.touches[0];
            const contentHeight = contentRef.current.clientHeight;

            if ((window.innerHeight - contentHeight) <= (clientY - 80)) {
                bodyRef.current.style.height = 'calc(100vh - ' + clientY + 'px)';
            }
        }
    };


    useEffect(() => {
        headerRef.current.addEventListener('touchend', handleDragEnd, false);
        headerRef.current.addEventListener('touchmove', handleDrag, false);

        return () => {
            headerRef.current.removeEventListener('touchend', handleDrag);
            headerRef.current.removeEventListener('touchmove', handleDrag);
        };
    }, []);

    useEffect(() => {
        const contentHeight = contentRef.current.clientHeight;

        if (window.innerWidth < 768) {
            const windowsHeight = window.innerHeight;
            if (contentHeight < windowsHeight) {
                bodyRef.current.style.height = 'auto';
            } else {
                bodyRef.current.style.height = 'calc(100vh - 80px)';
            }
        }
    });

    return ReactDOM.createPortal(
        <div className={"modal-container " + (className ?? '') + ' ' + (show ? 'd-block' : 'd-none')} ref={containerRef}>
            <div ref={backdropRef} onClick={(e) => handleClose(e)} className={"modal-back-drop fade " + (show ? 'in' : '')}/>


            <div ref={bodyRef} role="dialog" className={'modal-dialog bottom ' + (show ? 'show-modal slide-in ' : 'slide-out ') + (modalDialogClass ?? '') + ((!isEmpty(scrollable) && scrollable) ? ' modal-dialog-scrollable ' : '')}>
                <div className="position-relative w-100 h-100">
                    <div className="modal-dialog-content" ref={contentRef}>
                        <div className="modal-dialog-header" ref={headerRef} onClick={(e) => handleClose(e)}>
                            <div className="modal-header-close-line"/>
                        </div>

                        {
                            (windowSize > 991 && !isEmpty(scrollable) && scrollable) ?
                                <PerfectScrollbar>
                                    <div className={"modal-dialog-body " + (dialogBodyClassName ?? '')}>
                                        <ButtonTransparent className="modal-close icon-btn" onClick={(e) => handleClose(e)}>
                                            <i className="icons"><CloseIcon/></i>
                                        </ButtonTransparent>

                                        {children}
                                    </div>
                                </PerfectScrollbar>
                                :
                                <div className={"modal-dialog-body " + (dialogBodyClassName ?? '')}>
                                    <ButtonTransparent className="modal-close icon-btn" onClick={(e) => handleClose(e)}>
                                        <i className="icons"><CloseIcon/></i>
                                    </ButtonTransparent>

                                    {children}
                                </div>
                        }
                    </div>
                </div>
            </div>
        </div>
        ,
        document.body
    )
};

/**
 * @return {string}
 */
function Modal(props) {
    if (props.show) {
        return <Portal {...props}/>
    } else {
        return '';
    }
}

export default Modal;